import { Type } from '@angular/core';

export interface StaticForm {
  typeName: string;
  id: string;
  langPath: string;
  latestVersion: number;
  components: {
    perform: () => Promise<Type<any>>;
    completed: () => Promise<Type<any>>;
  };
  styling: StaticFormsStyling;
}

export interface StaticFormsStyling {
  boldLabels: boolean;
}

const defaultStyling: StaticFormsStyling = {
  boldLabels: true
};

export const StaticForms: Record<string, StaticForm> = {
  ASRS_AS: {
    typeName: 'ASRS_AS',
    id: '5ea1cdb4-f362-443f-a44a-12a3585e023c',
    langPath: 'asrs-as',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/asrs-as/1.0/asrs-as.component').then((m) => m.AsrsASComponent),
      completed: () =>
        import('../_forms/asrs-as/1.0/completed/completed-asrs-as.component').then((m) => m.CompletedAsrsASComponent)
    },
    styling: defaultStyling
  },
  ASRS_Screening: {
    typeName: 'ASRS_Screening',
    id: '4781C763-D237-4F0D-9C09-FE3DFD6BCA6A',
    langPath: 'asrs-screening',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/asrs-screening/1.0/asrs-screening.component').then((m) => m.AsrsScreeningComponent),
      completed: () =>
        import('../_forms/asrs-screening/1.0/completed/completed-asrs-screening.component').then(
          (m) => m.CompletedAsrsScreeningComponent
        )
    },
    styling: defaultStyling
  },
  ASRS_U: {
    typeName: 'ASRS_U',
    id: 'ce14ee7f-e8e3-4417-95ab-81229ce48e7e',
    langPath: 'asrs-u',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/asrs-u/1.0/asrs-u.component').then((m) => m.AsrsUComponent),
      completed: () =>
        import('../_forms/asrs-u/1.0/completed/completed-asrs-u.component').then((m) => m.CompletedAsrsUComponent)
    },
    styling: defaultStyling
  },
  ASSIST_Y: {
    typeName: 'ASSIST_Y',
    id: 'B2D8D73E-9C66-4F96-9EDA-4152BB589348',
    langPath: 'assist-y',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/assist-y/1.0/assist-y.component').then((m) => m.AssistYComponent),
      completed: () =>
        import('../_forms/assist-y/1.0/completed/completed-assist-y.component').then((m) => m.CompletedAssistYComponent)
    },
    styling: defaultStyling
  },
  AS_18: {
    typeName: 'AS_18',
    id: '3e4da279-a8bc-47ce-a075-e4ddb0999846',
    langPath: 'as-18',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/as-18/1.0/as-18.component').then((m) => m.As18Component),
      completed: () =>
        import('../_forms/as-18/1.0/completed/completed-as-18.component').then((m) => m.CompletedAs18Component)
    },
    styling: defaultStyling
  },
  AUDIT: {
    typeName: 'AUDIT',
    id: '8CEC6327-7636-4792-B5F6-43D58BBA7662',
    langPath: 'audit',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/audit/1.0/audit.component').then((m) => m.AuditComponent),
      completed: () =>
        import('../_forms/audit/1.0/completed/completed-audit.component').then((m) => m.CompletedAuditComponent)
    },
    styling: defaultStyling
  },
  AUDIT_C: {
    typeName: 'AUDIT_C',
    id: '406521CD-925F-411C-B70F-F30C83927C1A',
    langPath: 'audit-c',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/audit-c/1.0/audit-c.component').then((m) => m.AuditCComponent),
      completed: () =>
        import('../_forms/audit-c/1.0/completed/completed-audit-c.component').then((m) => m.CompletedAuditCComponent)
    },
    styling: defaultStyling
  },
  BloodPressure_Measurement: {
    typeName: 'BloodPressure_Measurement',
    id: '1FB643D2-88C5-4552-82CE-AE0CC69EE7A6',
    langPath: 'blood-measurement',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/blood-measurement/1.0/blood-measurement.component').then((m) => m.BloodMeasurementComponent),
      completed: () =>
        import('../_forms/blood-measurement/1.0/completed/completed-blood-measurement.component').then(
          (m) => m.CompletedBloodMeasurementComponent
        )
    },
    styling: defaultStyling
  },
  BN_20: {
    typeName: 'BN_20',
    id: '196BBE8C-C894-4EB3-8A76-00CD17409BC5',
    langPath: 'bn-20',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/bn-20/1.0/bn-20.component').then((m) => m.Bn20Component),
      completed: () =>
        import('../_forms/bn-20/1.0/completed/completed-bn-20.component').then((m) => m.CompletedBn20Component)
    },
    styling: defaultStyling
  },
  BSL_23: {
    typeName: 'BSL_23',
    id: '920FD2CB-21D8-4671-ACDE-D8B3473BDC0C',
    langPath: 'bsl-23',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/bsl-23/1.0/bsl-23.component').then((m) => m.Bsl23Component),
      completed: () =>
        import('../_forms/bsl-23/1.0/completed/completed-bsl-23.component').then((m) => m.CompletedBsl23Component)
    },
    styling: defaultStyling
  },
  CancerRehab: {
    typeName: 'CancerRehab',
    id: 'E54D853D-4A9F-4E0C-A0DA-F8F08B3C0000',
    langPath: 'cancerrehab',
    latestVersion: 2,
    components: {
      perform: () => import('../_forms/cancerrehab/2.0/cancerrehab.component').then((m) => m.CancerrehabComponent),
      completed: () =>
        import('../_forms/cancerrehab/2.0/completed/completed-cancerrehab.component').then(
          (m) => m.CompletedCancerrehabComponent
        )
    },
    styling: defaultStyling
  },
  CAT: {
    typeName: 'CAT',
    id: '75137A55-61A6-4756-A925-EBA1574CCA54',
    langPath: 'cat',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/cat/1.0/cat.component').then((m) => m.CATComponent),
      completed: () =>
        import('../_forms/cat/1.0/completed/completed-cat.component').then((m) => m.CompletedCATComponent)
    },
    styling: defaultStyling
  },
  CIA: {
    typeName: 'CIA',
    id: 'B134F130-84E6-40B5-9D6A-C3BF7810CBE9',
    langPath: 'cia',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/cia/1.0/cia.component').then((m) => m.CiaComponent),
      completed: () =>
        import('../_forms/cia/1.0/completed/completed-cia.component').then((m) => m.CompletedCiaComponent)
    },
    styling: defaultStyling
  },
  CGI_I: {
    typeName: 'CGI_I',
    id: 'FD305DA2-07F5-4D63-8324-976C3DBA686D',
    langPath: 'cgi-i',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/cgi-i/1.0/cgi-i.component').then((m) => m.CgiIComponent),
      completed: () =>
        import('../_forms/cgi-i/1.0/completed/completed-cgi-i.component').then((m) => m.CompletedCgiIComponent)
    },
    styling: defaultStyling
  },
  CGI_S: {
    typeName: 'CGI_S',
    id: '2D7B8FE8-3232-44C9-9700-9FB2C04EE875',
    langPath: 'cgi-s',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/cgi-s/1.0/cgi-s.component').then((m) => m.CgiSComponent),
      completed: () =>
        import('../_forms/cgi-s/1.0/completed/completed-cgi-s.component').then((m) => m.CompletedCgiSComponent)
    },
    styling: defaultStyling
  },
  Cleft_Q: {
    typeName: 'Cleft_Q',
    id: '3BA3B9FF-A048-46FE-8EB6-57D05C9E4474',
    langPath: 'cleft-q',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/cleft-q/1.0/cleft-q.component').then((m) => m.CleftQComponent),
      completed: () =>
        import('../_forms/cleft-q/1.0/completed/completed-cleft-q.component').then((m) => m.CompletedCleftQComponent)
    },
    styling: defaultStyling
  },
  CPRS_MemoryDisturbance: {
    typeName: 'CPRS_MemoryDisturbance',
    id: '4b5ca8f4-8ea2-4b60-98d8-f73a1dc50540',
    langPath: 'cprs-minnesstorning',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/cprs-minnesstorning/1.0/cprs-minnesstorning.component').then(
          (m) => m.CprsMinnesstorningComponent
        ),
      completed: () =>
        import('../_forms/cprs-minnesstorning/1.0/completed/completed-cprs-minnesstorning.component').then(
          (m) => m.CompletedCprsMinnesstorningComponent
        )
    },
    styling: defaultStyling
  },
  CPRS30: {
    typeName: 'CPRS30',
    id: '955cb1c9-0209-4054-b2fa-c75241c512d7',
    langPath: 'cprs30',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/cprs30/1.0/cprs30.component').then((m) => m.Cprs30Component),
      completed: () =>
        import('../_forms/cprs30/1.0/completed/completed-cprs30.component').then((m) => m.CompletedCprs30Component)
    },
    styling: defaultStyling
  },
  CRAFFT: {
    typeName: 'CRAFFT',
    id: 'CE28BA95-3941-4D38-B1FD-5A836C9C4A6A',
    langPath: 'crafft',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/crafft/1.0/crafft.component').then((m) => m.CrafftComponent),
      completed: () =>
        import('../_forms/crafft/1.0/completed/completed-crafft.component').then((m) => m.CompletedCrafftComponent)
    },
    styling: defaultStyling
  },
  DERS16: {
    typeName: 'DERS16',
    id: 'D6560DA8-7B0E-4B99-986D-939725E35BE1',
    langPath: 'ders-16',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/ders-16/1.0/ders-16.component').then((m) => m.Ders16Component),
      completed: () =>
        import('../_forms/ders-16/1.0/completed/completed-ders-16.component').then((m) => m.CompletedDers16Component)
    },
    styling: defaultStyling
  },
  Diabetes: {
    typeName: 'Diabetes',
    id: 'B51E5805-1A90-47B7-B68E-438FC61B2592',
    langPath: 'diabetes',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/diabetes/1.0/diabetes.component').then((m) => m.DiabetesComponent),
      completed: () =>
        import('../_forms/diabetes/1.0/completed/completed-diabetes.component').then(
          (m) => m.CompletedDiabetesComponent
        )
    },
    styling: defaultStyling
  },
  DIP_Q: {
    typeName: 'DIP_Q',
    id: '370bdf4c-5214-44dc-afa0-fbf456671010',
    langPath: 'dip-q',
    latestVersion: 2,
    components: {
      perform: () => import('../_forms/dip-q/2.0/dip-q.component').then((m) => m.DipQVer2Component),
      completed: () =>
        import('../_forms/dip-q/2.0/completed/completed-dip-q.component').then((m) => m.CompletedDipQVer2Component)
    },
    styling: defaultStyling
  },
  DIVA2: {
    typeName: 'DIVA2',
    id: '9E23F72C-335A-4516-8062-532283FBD324',
    langPath: 'diva2',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/diva2/1.0/diva2.component').then((m) => m.Diva2Component),
      completed: () =>
        import('../_forms/diva2/1.0/completed/completed-diva2.component').then((m) => m.CompletedDiva2Component)
    },
    styling: defaultStyling
  },
  DSHI_9R: {
    typeName: 'DSHI_9R',
    id: '99C29460-0DA9-4EC7-886A-C77836EF28B9',
    langPath: 'dshi-9r',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/dshi-9r/1.0/dshi-9r.component').then((m) => m.Dshi9rComponent),
      completed: () =>
        import('../_forms/dshi-9r/1.0/completed/completed-dshi-9r.component').then((m) => m.CompletedDshi9rComponent)
    },
    styling: defaultStyling
  },
  DUDIT: {
    typeName: 'DUDIT',
    id: '93ACF14B-76A1-46AF-B1AA-DE931AB3530F',
    langPath: 'dudit',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/dudit/1.0/dudit.component').then((m) => m.DuditComponent),
      completed: () =>
        import('../_forms/dudit/1.0/completed/completed-dudit.component').then((m) => m.CompletedDuditComponent)
    },
    styling: defaultStyling
  },
  EDE_Q: {
    typeName: 'EDE_Q',
    id: 'D9197E30-D7A6-4AFD-9269-16556B544406',
    langPath: 'ede-q',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/ede-q/1.0/ede-q.component').then((m) => m.EdeQComponent),
      completed: () =>
        import('../_forms/ede-q/1.0/completed/completed-ede-q.component').then((m) => m.CompletedEdeQComponent)
    },
    styling: defaultStyling
  },
  EHP_30: {
    typeName: 'EHP_30',
    id: '4231CFD0-BB99-4F30-9CC6-B4D3044A08F1',
    langPath: 'ehp-30',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/ehp-30/1.0/ehp-30.component').then((m) => m.Ehp30Component),
      completed: () =>
        import('../_forms/ehp-30/1.0/completed/completed-ehp-30.component').then((m) => m.CompletedEhp30Component)
    },
    styling: defaultStyling
  },
  EQ_5D: {
    typeName: 'EQ_5D',
    id: '3C48E0C0-C429-4374-B232-05F214866F8E',
    langPath: 'eq-5d-3l',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/eq-5d-3l/1.0/eq-5d-3l.component').then((m) => m.EQ5D3LComponent),
      completed: () =>
        import('../_forms/eq-5d-3l/1.0/completed/completed-eq-5d-3l.component').then((m) => m.CompletedEQ5D3LComponent)
    },
    styling: defaultStyling
  },
  EQ_5D_5L: {
    typeName: 'EQ_5D_5L',
    id: 'DF5DB610-3612-44FC-B09B-4B6517CCA56E',
    langPath: 'eq-5d-5l',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/eq-5d-5l/1.0/eq-5d-5l.component').then((m) => m.EQ5D5LComponent),
      completed: () =>
        import('../_forms/eq-5d-5l/1.0/completed/completed-eq-5d-5l.component').then((m) => m.CompletedEQ5D5LComponent)
    },
    styling: defaultStyling
  },
  Five_Fifteen: {
    typeName: 'Five_Fifteen',
    id: '20A8B839-2DB5-4D45-B572-86DAE577B74C',
    langPath: '5-15',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/5-15/1.0/five-fifteen.component').then((m) => m.FiveFifteenComponent),
      completed: () =>
        import('../_forms/5-15/1.0/completed/completed-five-fifteen.component').then(
          (m) => m.CompletedFiveFifteenComponent
        )
    },
    styling: defaultStyling
  },
  GAD_7: {
    typeName: 'GAD_7',
    id: '7B551144-1CA3-4DFD-B513-8D8B0E56B083',
    langPath: 'gad-7',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/gad-7/1.0/gad-7.component').then((m) => m.Gad7Component),
      completed: () =>
        import('../_forms/gad-7/1.0/completed/completed-gad-7.component').then((m) => m.CompletedGad7Component)
    },
    styling: defaultStyling
  },
  GSRS: {
    typeName: 'GSRS',
    id: '7CD0BE03-5B3C-4885-BA74-F720A48D6867',
    langPath: 'gsrs',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/gsrs/1.0/gsrs.component').then((m) => m.GsrsComponent),
      completed: () =>
        import('../_forms/gsrs/1.0/completed/completed-gsrs.component').then((m) => m.CompletedGsrsComponent)
    },
    styling: defaultStyling
  },
  HAD: {
    typeName: 'HAD',
    id: '2A36E038-B4DA-4859-83C2-445FF15D8BFD',
    langPath: 'had',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/had/1.0/had.component').then((m) => m.HadComponent),
      completed: () =>
        import('../_forms/had/1.0/completed/completed-had.component').then((m) => m.CompletedHadComponent)
    },
    styling: defaultStyling
  },
  HealthSurvey_GynAnesthesia: {
    typeName: 'HealthSurvey_GynAnesthesia',
    id: '74BED27E-6F08-48D4-9665-5F03C4DCE69F',
    langPath: 'healthsurvey-gynanesthesia',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/healthsurvey-gynanesthesia/1.0/healthsurvey-gynanesthesia.component').then(
          (m) => m.HealthsurveyGynanesthesiaComponent
        ),
      completed: () =>
        import(
          '../_forms/healthsurvey-gynanesthesia/1.0/completed/completed-healthsurvey-gynanesthesia.component'
        ).then((m) => m.CompletedHealthsurveyGynanesthesiaComponent)
    },
    styling: defaultStyling
  },
  HealthSurvey_PreOperation3: {
    typeName: 'HealthSurvey_PreOperation',
    id: '45DD04A9-7E44-4B04-A7EE-DAD471106693',
    langPath: 'healthsurvey-preoperation',
    latestVersion: 3,
    components: {
      perform: () =>
        import('../_forms/healthsurvey-preoperation/3.0/healthsurvey-preoperation.component').then(
          (m) => m.HealthsurveyPreoperationV3Component
        ),
      completed: () =>
        import('../_forms/healthsurvey-preoperation/3.0/completed/completed-healthsurvey-preoperation.component').then(
          (m) => m.CompletedHealthsurveyPreoperationV3Component
        )
    },
    styling: defaultStyling
  },
  HealthSurvey_PreOperation4: {
    typeName: 'HealthSurvey_PreOperation',
    id: '45DD04A9-7E44-4B04-A7EE-DAD471106693',
    langPath: 'healthsurvey-preoperation',
    latestVersion: 4,
    components: {
      perform: () =>
        import('../_forms/healthsurvey-preoperation/4.0/healthsurvey-preoperation.component').then(
          (m) => m.HealthsurveyPreoperationV4Component
        ),
      completed: () =>
        import('../_forms/healthsurvey-preoperation/4.0/completed/completed-healthsurvey-preoperation.component').then(
          (m) => m.CompletedHealthsurveyPreoperationV4Component
        )
    },
    styling: defaultStyling
  },
  I_PSS: {
    typeName: 'I_PSS',
    id: '130BA2C0-5E38-4E4C-A8B5-C3772E767920',
    langPath: 'i-pss',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/i-pss/1.0/i-pss.component').then((m) => m.IPssComponent),
      completed: () =>
        import('../_forms/i-pss/1.0/completed/completed-i-pss.component').then((m) => m.CompletedIPssComponent)
    },
    styling: defaultStyling
  },
  ICS_Barn: {
    typeName: 'ICS_Barn',
    id: '1E9BB65D-F5B8-4B85-B4AB-7D6FDA01C31D',
    langPath: 'ics-child',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/ics-child/1.0/ics-child.component').then((m) => m.IcsChildComponent),
      completed: () =>
        import('../_forms/ics-child/1.0/completed/completed-ics-child.component').then(
          (m) => m.CompletedIcsChildComponent
        )
    },
    styling: defaultStyling
  },
  ICS_Vuxen: {
    typeName: 'ICS_Vuxen',
    id: '3157E253-B7C4-4DDE-B49A-5E4376C90327',
    langPath: 'ics-adult',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/ics-adult/1.0/ics-adult.component').then((m) => m.IcsAdultComponent),
      completed: () =>
        import('../_forms/ics-adult/1.0/completed/completed-ics-adult.component').then(
          (m) => m.CompletedIcsAdultComponent
        )
    },
    styling: defaultStyling
  },
  KABOSS_S: {
    typeName: 'KABOSS_S',
    id: 'B55B299F-F1CF-4C4E-BFE1-10CCAF718032',
    langPath: 'kaboss-s',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/kaboss-s/1.0/kaboss-s.component').then((m) => m.KabossSComponent),
      completed: () =>
        import('../_forms/kaboss-s/1.0/completed/completed-kaboss-s.component').then((m) => m.CompletedKabossSComponent)
    },
    styling: defaultStyling
  },
  Levnadsvanor: {
    typeName: 'Levnadsvanor',
    id: '11FA4ADB-A2CD-4510-AD81-79A7EBF05FA6',
    langPath: 'levnadsvanor',
    latestVersion: 3,
    components: {
      perform: () => import('../_forms/levnadsvanor/3.0/levnadsvanor.component').then((m) => m.LevnadsvanorComponent),
      completed: () =>
        import('../_forms/levnadsvanor/3.0/completed/completed-levnadsvanor.component').then(
          (m) => m.CompletedLevnadsvanorComponent
        )
    },
    styling: defaultStyling
  },
  Levnadsvanor_Heart: {
    typeName: 'Levnadsvanor_Heart',
    id: '8A2175CA-A89A-4929-9815-92FE4D015A3B',
    langPath: 'levnadsvanor-heart',
    latestVersion: 2,
    components: {
      perform: () =>
        import('../_forms/levnadsvanor-heart/2.0/levnadsvanor-heart.component').then(
          (m) => m.LevnadsvanorHeartComponent
        ),
      completed: () =>
        import('../_forms/levnadsvanor-heart/2.0/completed/completed-levnadsvanor-heart.component').then(
          (m) => m.CompletedLevnadsvanorHeartComponent
        )
    },
    styling: defaultStyling
  },
  LILA: {
    typeName: 'LILA',
    id: '7C47B6E2-C436-4E60-B61B-B24CF88C6141',
    langPath: 'lila',
    latestVersion: 2,
    components: {
      perform: () => import('../_forms/lila/2.0/lila.component').then((m) => m.LilaComponent),
      completed: () =>
        import('../_forms/lila/2.0/completed/completed-lila.component').then((m) => m.CompletedLilaComponent)
    },
    styling: defaultStyling
  },
  LSAS_SR: {
    typeName: 'LSAS_SR',
    id: 'B25F5FED-A7EF-4E90-93A5-7FE80405AB68',
    langPath: 'lsas-sr',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/lsas-sr/1.0/lsas-sr.component').then((m) => m.LsasSrComponent),
      completed: () =>
        import('../_forms/lsas-sr/1.0/completed/completed-lsas-sr.component').then((m) => m.CompletedLsasSrComponent)
    },
    styling: defaultStyling
  },
  LYQLI: {
    typeName: 'LyQLI',
    id: 'AC7A626F-3E94-4866-BB84-3487B02044EB',
    langPath: 'lyqli',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/lyqli/1.0/lyqli.component').then((m) => m.LyQLIComponent),
      completed: () =>
        import('../_forms/lyqli/1.0/completed/completed-lyqli.component').then((m) => m.CompletedLyQLIComponent)
    },
    styling: defaultStyling
  },
  MADRS: {
    typeName: 'MADRS',
    id: '0FF2F2EC-B180-4660-90F0-7947ACA3C447',
    langPath: 'madrs',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/madrs/1.0/madrs.component').then((m) => m.MadrsComponent),
      completed: () =>
        import('../_forms/madrs/1.0/completed/completed-madrs.component').then((m) => m.CompletedMadrsComponent)
    },
    styling: defaultStyling
  },
  MADRS_S: {
    typeName: 'MADRS_S',
    id: 'C42B287D-0A6A-4FEC-BD7C-8FB8B26358A2',
    langPath: 'madrs-s',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/madrs-s/1.0/madrs-s.component').then((m) => m.MadrsSComponent),
      completed: () =>
        import('../_forms/madrs-s/1.0/completed/completed-madrs-s.component').then((m) => m.CompletedMadrsSComponent)
    },
    styling: defaultStyling
  },
  MDQ: {
    typeName: 'MDQ',
    id: 'cd22ae14-fccb-4399-abb8-87a64d95e34f',
    langPath: 'mdq',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/mdq/1.0/mdq.component').then((m) => m.MdqComponent),
      completed: () =>
        import('../_forms/mdq/1.0/completed/completed-mdq.component').then((m) => m.CompletedMdqComponent)
    },
    styling: defaultStyling
  },
  MFS: {
    typeName: 'MFS',
    id: '04A0FF3C-8B8F-4199-8A10-B102EBBA908B',
    langPath: 'mfs',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/mfs/1.0/mfs.component').then((m) => m.MfsComponent),
      completed: () =>
        import('../_forms/mfs/1.0/completed/completed-mfs.component').then((m) => m.CompletedMfsComponent)
    },
    styling: defaultStyling
  },
  MIA: {
    typeName: 'MIA',
    id: '8565EDF0-6414-4E68-8426-F6B912AF4054',
    langPath: 'mia',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/mia/1.0/mia.component').then((m) => m.MiaComponent),
      completed: () =>
        import('../_forms/mia/1.0/completed/completed-mia.component').then((m) => m.CompletedMiaComponent)
    },
    styling: defaultStyling
  },
  MOS_SSS: {
    typeName: 'MOS_SSS',
    id: 'ECEDE9F2-6C9E-437B-8FBA-2D7C7353A534',
    langPath: 'mos-sss',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/mos-sss/1.0/mos-sss.component').then((m) => m.MosSSSComponent),
      completed: () =>
        import('../_forms/mos-sss/1.0/completed/completed-mos-sss.component').then((m) => m.CompletedMosSSSComponent)
    },
    styling: defaultStyling
  },
  NPI_NH: {
    typeName: 'NPI_NH',
    id: '9cc6353f-84de-413e-b40b-409588bd527b',
    langPath: 'npi-nh',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/npi-nh/1.0/npi-nh.component').then((m) => m.NpiNhComponent),
      completed: () =>
        import('../_forms/npi-nh/1.0/completed/completed-npi-nh.component').then((m) => m.CompletedNpiNhComponent)
    },
    styling: defaultStyling
  },
  OCI_R: {
    typeName: 'OCI_R',
    id: '7890C56A-17E3-459F-95B3-235A9F43A359',
    langPath: 'oci-r',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/oci-r/1.0/oci-r.component').then((m) => m.OciRComponent),
      completed: () =>
        import('../_forms/oci-r/1.0/completed/completed-oci-r.component').then((m) => m.CompletedOciRComponent)
    },
    styling: defaultStyling
  },
  OMPSQ_Short: {
    typeName: 'OMPSQ_Short',
    id: '9E0C980F-098A-40DE-8114-5793AC79A96B',
    langPath: 'ompsq',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/ompsq/1.0/ompsq.component').then((m) => m.OmpsqComponent),
      completed: () =>
        import('../_forms/ompsq/1.0/completed/completed-ompsq.component').then((m) => m.CompletedOmpsqComponent)
    },
    styling: defaultStyling
  },
  OP: {
    typeName: 'OP',
    id: 'A59B91FE-9CE3-4234-A9AA-FCBE7C773A74',
    langPath: 'op',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/op/1.0/op.component').then((m) => m.OPComponent),
      completed: () => import('../_forms/op/1.0/completed/completed-op.component').then((m) => m.CompletedOPComponent)
    },
    styling: defaultStyling
  },
  P_SEC_C: {
    typeName: 'P_SEC_C',
    id: 'E6ACA107-10F5-435E-9B90-02BA77E56FDD',
    langPath: 'p-sec-c',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/p-sec-c/1.0/p-sec-c.component').then((m) => m.PSecCComponent),
      completed: () =>
        import('../_forms/p-sec-c/1.0/completed/completed-p-sec-c.component').then((m) => m.CompletedPSecCComponent)
    },
    styling: defaultStyling
  },
  P_SEC_P: {
    typeName: 'P_SEC_P',
    id: 'E9782C0F-2D2A-4D89-A616-3578DDA9EBC8',
    langPath: 'p-sec-p',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/p-sec-p/1.0/p-sec-p.component').then((m) => m.PSecPComponent),
      completed: () =>
        import('../_forms/p-sec-p/1.0/completed/completed-p-sec-p.component').then((m) => m.CompletedPSecPComponent)
    },
    styling: defaultStyling
  },
  PCL_5_Initial: {
    typeName: 'PCL_5_Initial',
    id: '0FA417C2-D288-457A-AAB6-9FCDDFBE9465',
    langPath: 'pcl-5-initial',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/pcl-5-initial/1.0/pcl-5-initial.component').then((m) => m.Pcl5InitialComponent),
      completed: () =>
        import('../_forms/pcl-5-initial/1.0/completed/completed-pcl-5-initial.component').then(
          (m) => m.CompletedPcl5InitialComponent
        )
    },
    styling: defaultStyling
  },
  PCS: {
    typeName: 'PCS',
    id: '3BF5F7AF-A3ED-4E99-B4E6-04F385856A24',
    langPath: 'pcs',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/pcs/1.0/pcs.component').then((m) => m.PcsComponent),
      completed: () =>
        import('../_forms/pcs/1.0/completed/completed-pcs.component').then((m) => m.CompletedPcsComponent)
    },
    styling: defaultStyling
  },
  PDSS_SR: {
    typeName: 'PDSS_SR',
    id: 'F96A00DC-2E58-4E03-A520-2BDDB5D1925F',
    langPath: 'pdss-sr',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/pdss-sr/1.0/pdss-sr.component').then((m) => m.PdssSrComponent),
      completed: () =>
        import('../_forms/pdss-sr/1.0/completed/completed-pdss-sr.component').then((m) => m.CompletedPdssSrComponent)
    },
    styling: defaultStyling
  },
  PHQ_9: {
    typeName: 'PHQ_9',
    id: 'B7FA848D-1342-49BF-9F99-C8A86857A685',
    langPath: 'phq-9',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/phq-9/1.0/phq-9.component').then((m) => m.Phq9Component),
      completed: () =>
        import('../_forms/phq-9/1.0/completed/completed-phq-9.component').then((m) => m.CompletedPhq9Component)
    },
    styling: defaultStyling
  },
  PROM: {
    // PROM Allmän
    typeName: 'PROM',
    id: '8B7B4F6B-6D89-499A-BD29-04E323ABC7C0',
    langPath: 'prom-general',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/prom-general/1.0/prom-general.component').then((m) => m.PromGeneralComponent),
      completed: () =>
        import('../_forms/prom-general/1.0/completed/completed-prom-general.component').then(
          (m) => m.CompletedPromGeneralComponent
        )
    },
    styling: defaultStyling
  },
  PROM_Breast: {
    typeName: 'PROM_Breast',
    id: 'C7CC72DC-415A-4E27-B9A8-9C35034BD9EC',
    langPath: 'prom-breast',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/prom-breast/1.0/prom-breast.component').then((m) => m.PromBreastComponent),
      completed: () =>
        import('../_forms/prom-breast/1.0/completed/completed-prom-breast.component').then(
          (m) => m.CompletedPromBreastComponent
        )
    },
    styling: defaultStyling
  },
  PSS_10: {
    typeName: 'PSS_10',
    id: '5bb6feee-452e-454a-948f-5812492ac465',
    langPath: 'pss-10',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/pss-10/1.0/pss-10.component').then((m) => m.Pss10Component),
      completed: () =>
        import('../_forms/pss-10/1.0/completed/completed-pss-10.component').then((m) => m.CompletedPss10Component)
    },
    styling: defaultStyling
  },
  PSWQ: {
    typeName: 'PSWQ',
    id: '75FFE6F2-7B35-4AB9-ADAD-EC9CBD7EE543',
    langPath: 'pswq',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/pswq/1.0/pswq.component').then((m) => m.PswqComponent),
      completed: () =>
        import('../_forms/pswq/1.0/completed/completed-pswq.component').then((m) => m.CompletedPswqComponent)
    },
    styling: defaultStyling
  },
  RAADS_14: {
    typeName: 'RAADS_14',
    id: 'C51E8EA2-0093-4E17-AD15-AAD08342FA72',
    langPath: 'raads-14',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/raads-14/1.0/raads-14.component').then((m) => m.Raads14Component),
      completed: () =>
        import('../_forms/raads-14/1.0/completed/completed-raads-14.component').then((m) => m.CompletedRaads14Component)
    },
    styling: defaultStyling
  },
  RAND_36: {
    typeName: 'RAND_36',
    id: '4B9E6E42-FC3A-47E3-90C3-86B6644C153A',
    langPath: 'rand-36',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/rand-36/1.0/rand-36.component').then((m) => m.Rand36Component),
      completed: () =>
        import('../_forms/rand-36/1.0/completed/completed-rand-36.component').then((m) => m.CompletedRand36Component)
    },
    styling: defaultStyling
  },
  RCADS_C: {
    typeName: 'RCADS_C',
    id: '1F5260C8-EB21-4271-B866-87AE147872F1',
    langPath: 'rcads-c',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/rcads-c/1.0/rcads-c.component').then((m) => m.RcadsCComponent),
      completed: () =>
        import('../_forms/rcads-c/1.0/completed/completed-rcads-c.component').then((m) => m.CompletedRcadsCComponent)
    },
    styling: defaultStyling
  },
  RCADS_P: {
    typeName: 'RCADS_P',
    id: '4FF3D8D7-9C16-4320-9F48-14386E889B86',
    langPath: 'rcads-p',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/rcads-p/1.0/rcads-p.component').then((m) => m.RcadsPComponent),
      completed: () =>
        import('../_forms/rcads-p/1.0/completed/completed-rcads-p.component').then((m) => m.CompletedRcadsPComponent)
    },
    styling: defaultStyling
  },
  Rheumatic: {
    typeName: 'Rheumatic',
    id: 'C735252F-86E7-4243-8816-A0D5A2D0412A',
    langPath: 'rheumatic',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/rheumatic/1.0/rheumatic.component').then((m) => m.RheumaticComponent),
      completed: () =>
        import('../_forms/rheumatic/1.0/completed/completed-rheumatic.component').then(
          (m) => m.CompletedRheumaticComponent
        )
    },
    styling: defaultStyling
  },
  RHI: {
    typeName: 'RHI',
    id: '3D634F15-7CF0-4B81-AF85-BB0B33F5116F',
    langPath: 'rhi',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/rhi/1.0/rhi.component').then((m) => m.RhiComponent),
      completed: () =>
        import('../_forms/rhi/1.0/completed/completed-rhi.component').then((m) => m.CompletedRhiComponent)
    },
    styling: defaultStyling
  },
  SCI: {
    typeName: 'SCI',
    id: '7C2A1266-3CCA-4C3D-B150-5129E62120C9',
    langPath: 'sci',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/sci/1.0/sci.component').then((m) => m.SciComponent),
      completed: () =>
        import('../_forms/sci/1.0/completed/completed-sci.component').then((m) => m.CompletedSciComponent)
    },
    styling: defaultStyling
  },
  SDS: {
    typeName: 'SDS',
    id: '0C361107-098F-4FAA-8A02-EDCFD9491EE3',
    langPath: 'sds',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/sds/1.0/sds.component').then((m) => m.SdsComponent),
      completed: () =>
        import('../_forms/sds/1.0/completed/completed-sds.component').then((m) => m.CompletedSdsComponent)
    },
    styling: defaultStyling
  },
  SDQ_B11: {
    // SDQ Barn självskattning (11 år -)
    typeName: 'SDQ_B11',
    id: 'E2A612C5-4820-47AC-A616-59016FEF26E8',
    langPath: 'sdq-child',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/sdq-child/1.0/sdq-child.component').then((m) => m.SdqChildComponent),
      completed: () =>
        import('../_forms/sdq-child/1.0/completed/completed-sdq-child.component').then(
          (m) => m.CompletedSdqChildComponent
        )
    },
    styling: defaultStyling
  },
  SDQ_B11_U: {
    // SDQ Barn självskattning (11 år -) Uppföljning
    typeName: 'SDQ_B11_U',
    id: '5CFE6627-EE87-41FA-BBCE-C24ECF3FA7FC',
    langPath: 'sdq-child-followup',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/sdq-child-followup/1.0/sdq-child-followup.component').then(
          (m) => m.SdqChildFollowupComponent
        ),
      completed: () =>
        import('../_forms/sdq-child-followup/1.0/completed/completed-sdq-child-followup.component').then(
          (m) => m.CompletedSdqChildFollowupComponent
        )
    },
    styling: defaultStyling
  },
  SDQ_F4: {
    // SDQ Förälderskattning (4 år - )
    typeName: 'SDQ_F4',
    id: 'B823AF79-1EEE-4104-BCA1-A7422C5B3718',
    langPath: 'sdq-parent',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/sdq-parent/1.0/sdq-parent.component').then((m) => m.SdqParentComponent),
      completed: () =>
        import('../_forms/sdq-parent/1.0/completed/completed-sdq-parent.component').then(
          (m) => m.CompletedSdqParentComponent
        )
    },
    styling: defaultStyling
  },
  SDQ_F4_U: {
    // SDQ Förälderskattning (4 år - ) Uppföljning
    typeName: 'SDQ_F4_U',
    id: 'B45A178F-AFA2-41DB-AED5-5C57C7B7F74B',
    langPath: 'sdq-parent-followup',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/sdq-parent-followup/1.0/sdq-parent-followup.component').then(
          (m) => m.SdqParentFollowUpComponent
        ),
      completed: () =>
        import('../_forms/sdq-parent-followup/1.0/completed/completed-sdq-parent-followup.component').then(
          (m) => m.CompletedSdqParentFollowUpComponent
        )
    },
    styling: defaultStyling
  },
  SHAI_14: {
    typeName: 'SHAI_14',
    id: 'bbbcd553-1e6b-4a1e-b910-d6f85fc19089',
    langPath: 'shai-14',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/shai-14/1.0/shai-14.component').then((m) => m.Shai14Component),
      completed: () =>
        import('../_forms/shai-14/1.0/completed/completed-shai-14.component').then((m) => m.CompletedShai14Component)
    },
    styling: defaultStyling
  },
  SIAS: {
    typeName: 'SIAS',
    id: '56073D94-3A02-4050-9877-C0D10CA0D023',
    langPath: 'sias',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/sias/1.0/sias.component').then((m) => m.SiasComponent),
      completed: () =>
        import('../_forms/sias/1.0/completed/completed-sias.component').then((m) => m.CompletedSiasComponent)
    },
    styling: defaultStyling
  },
  SNAP_IV: {
    typeName: 'SNAP_IV',
    id: 'E767B7E0-A891-44ED-A4A3-172FB3CC1C7D',
    langPath: 'snap-iv',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/snap-iv/1.0/snap-iv.component').then((m) => m.SnapIVComponent),
      completed: () =>
        import('../_forms/snap-iv/1.0/completed/completed-snap-iv.component').then((m) => m.CompletedSnapIVComponent)
    },
    styling: defaultStyling
  },
  SPS: {
    typeName: 'SPS',
    id: '10063D2C-DC1B-479F-BB74-0B4C58D774F2',
    langPath: 'sps',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/sps/1.0/sps.component').then((m) => m.SpsComponent),
      completed: () =>
        import('../_forms/sps/1.0/completed/completed-sps.component').then((m) => m.CompletedSpsComponent)
    },
    styling: defaultStyling
  },
  Start_Riskevaluation: {
    typeName: 'Start_Riskevaluation',
    id: 'AC615DE7-F75F-441D-9556-850521FEB11E',
    langPath: 'start-risk-evaluation',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/start-risk-evaluation/1.0/start-risk-evaluation.component').then(
          (m) => m.StartRiskEvaluationComponent
        ),
      completed: () =>
        import('../_forms/start-risk-evaluation/1.0/completed/completed-start-risk-evaluation.component').then(
          (m) => m.CompletedStartRiskEvaluationComponent
        )
    },
    styling: defaultStyling
  },
  SUPRA_CASEMIX: {
    typeName: 'Supra_Casemix',
    id: '48B9DD0A-3F4C-4265-A8D1-1EF030EAACA9',
    langPath: 'supra-casemix',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/supra-casemix/1.0/supra-casemix.component').then((m) => m.SupraCasemixComponent),
      completed: () =>
        import('../_forms/supra-casemix/1.0/completed/completed-supra-casemix.component').then(
          (m) => m.CompletedSupraCasemixComponent
        )
    },
    styling: defaultStyling
  },
  SUPRA_PREM: {
    typeName: 'Supra_Prem',
    id: 'DD133B89-8F99-40BB-86B1-20FA529C1410',
    langPath: 'supra-prem',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/supra-prem/1.0/supra-prem.component').then((m) => m.SupraPremComponent),
      completed: null
    },
    styling: defaultStyling
  },
  VAS: {
    typeName: 'VAS',
    id: 'BABE8070-1CD1-45CE-B2A1-A24ECD897D62',
    langPath: 'vas',
    latestVersion: 2,
    components: {
      perform: () => import('../_forms/vas/2.0/vas.component').then((m) => m.VasComponent),
      completed: () =>
        import('../_forms/vas/2.0/completed/completed-vas.component').then((m) => m.CompletedVasComponent)
    },
    styling: defaultStyling
  },
  V_RISK_10: {
    typeName: 'V_RISK_10',
    id: 'F619C08D-B8CF-432C-ADAF-F1197B17C941',
    langPath: 'v-risk-10',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/v-risk-10/1.0/v-risk-10.component').then((m) => m.VRisk10Component),
      completed: () =>
        import('../_forms/v-risk-10/1.0/completed/completed-v-risk-10.component').then(
          (m) => m.CompletedVRisk10Component
        )
    },
    styling: defaultStyling
  },
  WHODAS2_12: {
    typeName: 'WHODAS2_12',
    id: 'A310B4AA-FE5C-44AC-A33A-AC74059F8662',
    langPath: 'whodas-12',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/whodas-12/1.0/whodas-12.component').then((m) => m.Whodas12Component),
      completed: () =>
        import('../_forms/whodas-12/1.0/completed/completed-whodas-12.component').then(
          (m) => m.CompletedWhodas12Component
        )
    },
    styling: defaultStyling
  },
  WHODAS2_36: {
    typeName: 'WHODAS2_36',
    id: 'B0693599-D8B5-485F-B7A6-1A865228C654',
    langPath: 'whodas-36',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/whodas-36/1.0/whodas-36.component').then((m) => m.Whodas36Component),
      completed: () =>
        import('../_forms/whodas-36/1.0/completed/completed-whodas-36.component').then(
          (m) => m.CompletedWhodas36Component
        )
    },
    styling: defaultStyling
  },
  WURS_25: {
    typeName: 'WURS_25',
    id: '3279C44E-B76F-45FB-90F8-A16040B4701D',
    langPath: 'wurs-25',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/wurs-25/1.0/wurs-25.component').then((m) => m.Wurs25Component),
      completed: () =>
        import('../_forms/wurs-25/1.0/completed/completed-wurs-25.component').then((m) => m.CompletedWurs25Component)
    },
    styling: defaultStyling
  },
  Y_BOCS_Checklist: {
    typeName: 'Y_BOCS_Checklist',
    id: '9D34B483-5581-4F71-AB1A-B7EBCF5B645C',
    langPath: 'y-bocs-checklist',
    latestVersion: 1,
    components: {
      perform: () =>
        import('../_forms/y-bocs-checklist/1.0/y-bocs-checklist.component').then((m) => m.YBocsChecklistComponent),
      completed: () =>
        import('../_forms/y-bocs-checklist/1.0/completed/completed-y-bocs-checklist.component').then(
          (m) => m.CompletedYBocsChecklistComponent
        )
    },
    styling: defaultStyling
  },
  Y_BOCS_SR: {
    typeName: 'Y_BOCS_SR',
    id: 'BFE137B7-CFF7-482A-917A-985C2C3305EB',
    langPath: 'y-bocs-sr',
    latestVersion: 1,
    components: {
      perform: () => import('../_forms/y-bocs-sr/1.0/y-bocs-sr.component').then((m) => m.YBocsSrComponent),
      completed: () =>
        import('../_forms/y-bocs-sr/1.0/completed/completed-y-bocs-sr.component').then(
          (m) => m.CompletedYBocsSrComponent
        )
    },
    styling: defaultStyling
  }
};
